import { SmsTemplatesSortTypes } from './Interfaces';

export class SMSsHistoryFilter {
    public Keywords?: string | null = null;
    public Type?: string | null = null;
    public DateRange: string[] = [];
    public TimeRange: string[] = [];
    public Automation?: number | null = null;
    public Timezone: number = 0;
}
export interface SMSBatchResource {
    AutomationId: number | null;
    AutomationName: string | null;
    BatchGuid: string;
    CreatedAt: string | Date;
    FinishedAt: string | Date;
    ShedulledAt: string | Date;
    DateTime: string | Date;
    DeliverQty: number;
    ErrorMessage: string | null;
    FailedQty: number;
    Id: number;
    SentQty: number;
    Status: string | number;
    TemplateMessage: string;
    TemplateName: string;
    TotalQty: number;
    ContactGroups: number[];
    SmsProfileId: number | null;
}

export interface SMSBatchHistoryResult {
    LastId: number;
    HasNext: boolean;
    Rows: SMSBatchResource[];
}

export class SMSsProfilesFilter {
    public Keywords: string = '';
    public OrderBy: string = 'CreatedLast';
}
export class SmsTemplateFilter {
    public Keywords: string = '';
    public OrderBy: SmsTemplatesSortTypes = SmsTemplatesSortTypes.Name;
    public SortAsc = true;
}
export interface SMSProfileRowResource {
    Id: number;
    Name: string;
    From: string;
    CreatedAt: string | null;
}
export interface SMSTemplateResponse {
    SmsTemplate: EmailSMSTemplateRowResource;
    IsUsed: boolean;
}
export class EmailSMSTemplateRowResource {
    Id: string = '';
    Name: string = '';
    Message: string = '';
    CreatedAt: string | null = null;
    ChangeBoth: boolean = false;
    UpdatedAt: string | null = null;
    PreviewPath: string | null = null;
}
export interface SMSProfileResource extends SMSProfileRowResource {
    UpdatedAt?: string;
}
export interface SMSProfilesResult {
    PageIndex: number;
    HasNext: boolean;
    Rows: SMSProfileRowResource[];
}
export interface SMSTemplatesResult {
    PageIndex: number;
    HasNext: boolean;
    Rows: EmailSMSTemplateRowResource[];
}

export class FilterBy {
    dateRange: string = '';
    timeRange: string = '';
    template: number = 0;
    status: string = '';
    automation: number = 0;
}

export class PageModel {
    PreviewPath: string = '';
    Link: string = '';
    Id: string = '';
    Name: string = '';
    Title: string = '';
    UpdatedAt: Date | null = null;
}
export class SendSmsModel {
    public Id: number = 0;
    public Name: string = '';
    public Message: string | null = '';
    public ContactGroups: number[] = [];
    public SmsProfileId: number | null = null;
    public SmsTemplateId: string | null = null;
    public AddUnsubscribe = false;
    public UnsubscribeText: string | null = '';
    public ReplaceLink = false;
    public Scheduled = false;
    public ScheduledDate: string | null = null;
    public ScheduledTime: string | null = null;
    public ScheduledAt: Date | string | null = null;
}

export class SendTestSmsModel {
    public Mobile: string | null = '';
    public Message: string | null = '';
    public ReplaceLink = false;
    public AddUnsubscribe = false;
    public UnsubscribeText: string | null = '';
    public SmsProfileId: number | null = null;
}
